const e = {
  id: "NewYorkNumbers",
  logo: !0,
  name: "New York Numbers",
  style: {
    colorPrimary: "#2e73b5"
  }
};
export {
  e as default
};
